import type { OrganizationScope } from "@/types/organization-scope"
import { isOrganizationScopeSwitchable } from "@/utils/organizationScopeSwitch"

export function isScopeSwitchableForPermissions(scope: OrganizationScope, _permissionList: string[] = []) {
  // `/me/organizations` owns organization availability. The current SHOP token's
  // permissions must not suppress a valid headquarters-role assignment.
  return isOrganizationScopeSwitchable(scope)
}

export function isHqMenuEnabledForScope(scope: OrganizationScope | undefined, permissionList: string[] = []) {
  return (scope?.type === "chain-headquarter" || scope?.type === "chain-region")
    && isScopeSwitchableForPermissions(scope, permissionList)
}

export function findDefaultScopeForPermissions(scopes: OrganizationScope[], permissionList: string[] = []) {
  const switchableScopes = scopes.filter(scope => isScopeSwitchableForPermissions(scope, permissionList))
  return switchableScopes.find(scope => scope.type === "chain-headquarter")
    ?? switchableScopes.find(scope => scope.type === "chain-region")
    ?? switchableScopes.find(scope => scope.type === "shop" || scope.type === "chain-store")
    ?? switchableScopes[0]
}

export function ensureActiveScopeAllowedForPermissions(
  scopes: OrganizationScope[],
  activeScopeId: string,
  permissionList: string[] = [],
) {
  const activeScope = scopes.find(scope => scope.id === activeScopeId)
  if (activeScope && isScopeSwitchableForPermissions(activeScope, permissionList)) {
    return activeScopeId
  }
  return findDefaultScopeForPermissions(scopes, permissionList)?.id ?? ""
}

export function createRouteAccessContext(options: {
  activeScope?: OrganizationScope
  permissionList?: string[]
} = {}) {
  return {
    hqMenuEnabled: isHqMenuEnabledForScope(options.activeScope, options.permissionList),
    ...(options.activeScope ? { activeScopeType: options.activeScope.type } : {}),
    ...(options.activeScope?.capabilities ? { capabilities: options.activeScope.capabilities } : {}),
  }
}
